import React from 'react';

import { List } from '@lglp/components';
import { LinkType } from '@lglp/prismic-client';

import BreadcrumbIcon from '../../../components/icons/BreadcrumbIcon';
import { LinkedComponent } from '../../LinkedComponent';

export const BreadcrumbLink: React.FC<BreadcrumbLinkProps> = (props) => {
  const { url, title, current } = props;

  return (
    <List.Item>
      <LinkedComponent
        link={{
          url,
          linkType: LinkType.Web,
        }}
        aria-current={current ? 'page' : undefined}
      >
        {title}
      </LinkedComponent>
      {!current && <BreadcrumbIcon className="" />}
    </List.Item>
  );
};

type BreadcrumbLinkProps = {
  url: string;
  title: string;
  current?: boolean;
};
